import { CogTransferIcon } from './CogTransferIcon';

/**
 * author: Michael Richins
 * id 17CD5A77-2809-4DDC-B876-877D8B913217
 * name cog-transfer
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-transfer.svg
 * tags
 * - Settings 
 */
export const SettingsTransferIcon = CogTransferIcon;
export default SettingsTransferIcon